import ifvisible from 'ifvisible.js'
import moment from 'moment'
var onbeforeunload = {

  methods: {
    onLoadTime () {
      let self = this
      ifvisible.setIdleDuration(60 * 30)

      ifvisible.on('blur', () => {
        self.onloadTime = moment()
      })
      ifvisible.on('idle', () => {
        self.onloadTime = moment()
      })

      ifvisible.on('focus', () => {
        if (moment().diff(moment(self.onloadTime)) > 1000 * 60 * 30) {
          self.check()
        }
      })
      // ifvisible.on('wakeup', () => {
      //   if (moment().diff(moment(self.onloadTime)) > 1000 * 60 * 30) {
      //     self.check()
      //   }
      // })
    }
  }
}

export default onbeforeunload
